import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Waves from '../Waves';

export default class WaterModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);
        this.addChild(GameObject.Instantiate(Waves));
    }
}
